import { Component } from "react"
import PropTypes from "prop-types"
import Humanize from "humanize-plus"

import colors from "foundation/_colors_export.scss?variables"

export default class ConnectedServicesChart extends Component {
  getSettings(props, Highcharts) {
    const { servicesUrl, onDetailSelect } = this.props

    return {
      chart: {
        animation: false,
        renderTo: this.chartContainer,
        type: "pie",
      },
      title: {
        text: this.renderTitle(),
        align: "center",
        verticalAlign: "middle",
        useHTML: true,
        y: 0,
        style: { maxWidth: "120px", whiteSpace: "normal", textAlign: "center" },
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            distance: -50,
            formatter() {
              if (this.percentage > 3) {
                return `<img width="30" height="30" src='${this.point.icon}' alt=${this.point.name}></img>`
              }
            },
            useHTML: true,
            inside: true,
            style: {
              color:
                (Highcharts.theme && Highcharts.theme.contrastTextColor) ||
                colors.primaryTextColor,
            },
          },
        },
        series: {
          animation: false,
          colorByPoint: true,
          events: {
            click(event) {
              if (servicesUrl) {
                window.Turbolinks.visit(
                  `${servicesUrl}/${event.point.options.moduleName}`
                )
              } else {
                onDetailSelect(event.point.options.moduleName)
              }
            },
          },
        },
      },
      tooltip: {
        enabled: true,
        useHTML: true,
        headerFormat: "",
        padding: 0,
        backgroundColor: "#fff",
        borderColor: "#fff",
        pointFormat: `<div class='tooltip'><div class='header' style='background-color: {point.color};'><img src='{point.icon}' alt='{point.name}' width='25' height='25'/>{point.name}</div><div class='row'><p class='stat'>{point.percent}%</p><p>of your connections are to this service</p></div><div class='row'><p class='stat'>{point.total_connected}</p><p>total connected users</p></div></div>`,
      },
      series: [
        {
          name: "Connections",
          colorByPoint: true,
          colors: props.data.slice(0, props.count).map(item => {
            return "#" + item.channel.brand_color
          }),
          innerSize: "50%",
          data: props.data
            .slice(0, props.count)
            .filter(this.filterData.bind(null, props.totalUsers))
            .map(works_with => {
              return {
                y: works_with.activeUsers,
                name: works_with.channel.name,
                icon: works_with.channel.monochrome_image_url,
                color: `#${works_with.channel.brand_color}`,
                percent: Math.ceil(
                  (works_with.activeUsers / props.totalUsers) * 100
                ),
                total_connected: Humanize.compactInteger(
                  works_with.activeUsersAllTime,
                  1
                ),
                moduleName: works_with.channel.module_name,
              }
            }),
        },
      ],
    }
  }

  filterData(firstTimeUsers, item) {
    // Filter out items w/ less than 1% of users
    return item.activeUsers / firstTimeUsers > 0.01
  }

  async componentDidMount() {
    const Highcharts = await import("highcharts")
    Highcharts.setOptions(window.globalHighchartsOptions)

    this.chart = new Highcharts.Chart(this.getSettings(this.props, Highcharts))
  }

  async shouldComponentUpdate(nextProps) {
    const Highcharts = await import("highcharts")
    Highcharts.setOptions(window.globalHighchartsOptions)

    if (this.props.data !== nextProps.data) {
      this.chart.destroy()
      this.chart = new Highcharts.Chart(this.getSettings(nextProps, Highcharts))
    }
    return false
  }

  componentWillUnmount() {
    this.chart.destroy()
  }

  renderTitle() {
    return `Top services connected`
  }

  render() {
    return <div className="donut-chart" ref={c => (this.chartContainer = c)} />
  }
}

ConnectedServicesChart.propTypes = {
  data: PropTypes.array.isRequired,
  firstTimeUsers: PropTypes.number.isRequired,
  serviceName: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  servicesUrl: PropTypes.string,
  onDetailSelect: PropTypes.func,
}
